import { Button } from '@deliveryhero/pd-cookbook/components/ButtonV2';
import { Typography } from '@deliveryhero/pd-cookbook/components/Typography';

import { UnexpectedErrorIllustration } from 'components/svg/UnexpectedError';
import getConfig from 'src/utils/get-config/get-config';
import isFoodora from 'src/utils/is-foodora/is-foodora';

import { AppErrorFallbackProps } from './types';

export const AppErrorFallback = ({
  resetErrorBoundary,
  title,
  description,
  buttonLabel,
  showIllustration = true
}: AppErrorFallbackProps) => {
  const { contact_us: contactEmail } = getConfig();
  return (
    <div
      style={{
        margin: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      {!isFoodora() && showIllustration && (
        <UnexpectedErrorIllustration height={200} />
      )}
      <Typography type="title-lg">{title}</Typography>
      <Typography
        type="paragraph-md"
        style={{ marginTop: '8px', textAlign: 'center' }}
      >
        {description}{' '}
        <Typography as="span" type="title-sm">
          <a href={`mailto:${contactEmail}`} style={{ textDecoration: 'none' }}>
            {contactEmail}
          </a>
        </Typography>
      </Typography>
      {buttonLabel && (
        <Button
          variant="primary"
          onClick={resetErrorBoundary}
          style={{ marginTop: '24px' }}
        >
          {buttonLabel}
        </Button>
      )}
    </div>
  );
};
